import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const PekerjaanPascaService = {}

PekerjaanPascaService.getDataAll = function (token) {

    return fetch({
        url: '/ref/pekerjaan_pasca',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

PekerjaanPascaService.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/pekerjaan_pasca',
        method: 'get',
        params: {
            "id_pekerjaan":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default PekerjaanPascaService;
